import React, { useState, useEffect } from "react";
import CustomTable from "../../../../../customComponents/CustomTable";
import downloadIcon from "./../../../../../../Assets/icons/download.svg";
import searchIcon from "./../../../../../../Assets/icons/searchicon.svg";
import editIcon from "./../../../../../../Assets/icons/Un-Checkbox.svg";
import mailIcon from "./../../../../../../Assets/icons/mailIcon.svg";
import "./index.scss";
import ListFilters from "../../../OnBoardManagement/ListFilters";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { toastSuccess } from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import ListLogisticsFilters from "../../../../Logistics/LogisticsFilter";
import { IoMdClose } from "react-icons/io";
import * as base64 from "base-64";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { FiDownload } from "react-icons/fi";
import Swal from "sweetalert2";
import SearchInput from "../../../../../customComponents/CustomSearch/SearchInput";

const DealerList = () => {
  const [dealers, setDealers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [city, setCity] = useState([]);
  const [filters, setFilters] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [revenue, setRevenue] = useState(0);

  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const business_partner_id = localStorage.getItem("business_partner_id");
  const userType = localStorage.getItem("UserType");

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    // Format to YYYY-MM-DD without timezone influence
    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  useEffect(() => {
    // fetchDealers();
    fetchCity();
  }, []);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDealers(newPage);
  };

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.post(
        "/dealer/ddldealercity",
        {
          business_partner_id:
            userType === "superadmin" ? null : business_partner_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data.data; // Access the data from the response object
      const cityOptions = data.map((city) => ({
        value: city.ID,
        label: city.NAME,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };

  const fetchDealers = async (page = 0, pageSize = 10) => {
    // const allfilteredData = filteredData
    console.log(filters, "FILTERS");
    const allfilteredData = filters;

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/dealer/list",
        {
          orderBy: "dealer_id desc",
          page,
          pageSize,
          // startDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
          // endDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,

          startDate: formatDate(allfilteredData?.fromDate),
          endDate: formatDate(allfilteredData?.toDate),
          city_id: allfilteredData?.city ? allfilteredData?.city : null,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalActive = response?.data?.data?.total_active;
      const totalInActive = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalActive);
      setTotalInactive(totalInActive);
      // setRevenue(revenueCount)

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setDealers(formattedData);
      // toastSuccess("Dealer Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching dealer list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchInputChange = (event) => {
    const trimmedValue = event.target.value.trim();
    setSearchTerm(trimmedValue);
  };

  const handleKeyPress = (e) => {
    console.log("keyname", e.key);

    if (e.key === "Enter") {
      fetchDealers(0, 10, searchTerm);
    }
  };

  // Table headers
  const DEALER_TABLE_HEADERS = [
    // "Sr No.",
    "Dealer Name",
    "Dealer Code",
    "Email",
    "City",
    "Created Date",
    "Status",
    "Action",
  ];

  // Key mapping for CustomTable component
  const DEALER_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    "Dealer Code": "dealer_code",
    "Dealer Name": "dealer_name",
    Email: "email_id",
    "Created Date": "created_at",
    City: "city_name",
    Status: "status",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "mailDealer", icon: mailIcon, label: "Mail" },
    ],
  };

  const handleMailFunc = async (row) => {
    var text = row?.dealer_id;
    // var encoded = base64.encode(text);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to resent the mail details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.get(
            `/dealer/resendemail/${text}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.status === 200) {
            await showAlert({
              title: "Success",
              text: "Mail sent successfully.",
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        } catch (error) {
          console.error("Error fetching action taken list:", error);
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The dealer was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchDealers();
  };

  useEffect(() => {
    console.log("called");

    fetchDealers();
  }, [filters]);

  const handleSearch = () => {
    if (filterFormData.startDate && filterFormData.endDate) {
      const startDate = new Date(filterFormData.startDate);
      const endDate = new Date(filterFormData.endDate);
      if (endDate < startDate) {
        Swal.fire({
          title: "Invalid Date Range",
          text: "To Date cannot be earlier than From Date.",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
    }
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
    });
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITDEALER}`, { state: { data: rowData } });
    // console.log("rowdata", rowData)
  };

  const handleAddDealerNavigate = () => {
    navigate("/admin/manage-dealer/dealer/add-dealer");
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      // required: true,

      gridClass: "col-12 col-lg-2",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      // required: true,
      gridClass: "col-12 col-lg-2",
    },
    {
      name: "city_id",
      label: "City",
      placeholder: "Select City",
      type: "dropdown",
      options: city,
      // required: true,
      gridClass: "col-12 col-lg-2",
    },
  ];
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchDealers();
    }
  }, [searchTerm]);

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      startDate: formatDate(allfilteredData?.fromDate),
      endDate: formatDate(allfilteredData?.toDate),
      city_id: allfilteredData?.city ? allfilteredData?.city : null,
      searchText: searchTerm,
    };

    try {
      const response = await axiosInstance.post(
        "/dealer/dealer-report-excel",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "dealer.csv";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer row">
            <div className="OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2">
              <h5>Dealer Management</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Dealers</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{Number(totalActive)} </h5>
                <h6>Active Dealers</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">
                  {Number(totalInactive)}{" "}
                </h5>
                <h6>Inactive Dealers</h6>
              </div>

              <div>
                <button
                  className="addcustomerbutton"
                  onClick={handleAddDealerNavigate}
                >
                  Add Dealer
                </button>
              </div>
            </div>
          </div>

          {/* <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} /> */}
          <ListLogisticsFilters
            formConfig={PhysicalStockTakingInputs}
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleSearch}
            handleClear={clearFilter}
            // onSubmit={handleFormSubmit}
          />

          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Dealers List</h5>
                <div className="searchinput-wrapper">
                  {/* <input
                    type="text"
                    className="searchinput"
                    placeholder="Search Name, Code, Email"
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                    onKeyPress={handleKeyPress}
                  />
                  {searchTerm ? (
                    <IoMdClose
                      size={22}
                      className="searchinput-close-icon"
                      onClick={clearSearchAndFetch}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt="Search"
                      className="searchinput-icon"
                    />
                  )} */}
                  <SearchInput
                    placeholder="Search by Name, Code, Email"
                    onSearch={fetchDealers}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div
                  onClick={downloadExcel}
                  className="flte-btnnn"
                  style={{ borderRadius: "38px", cursor: "pointer" }}
                >
                  Export
                  <span>
                    {/* <img
                                                onClick={downloadExcel}
                                                src={DownloadSVG}
                                                alt="downloadSvg"
                                                className="downloadexcel-misreportsales"
                                                style={{
                                                  // paddingTop: "9rem",
                                                  // paddingRight: "1rem",
                                                  
                                                  cursor: "pointer",
                                                  height:"24px"
                                                }}
                                              /> */}
                    <FiDownload
                      className="downloadexcel-misreportsales"
                      style={{ cursor: "pointer" }}
                      size={22}
                    />
                  </span>
                </div>
              </div>
            </div>

            <CustomTable
              data={dealers}
              headers={DEALER_TABLE_HEADERS}
              keyMapping={DEALER_KEY_MAPPING}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
              handleMailFunc={handleMailFunc}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DealerList;
